// src/stores/auth.js
import { defineStore } from "pinia";
import { ref } from "vue";
import axios from "axios";

let fetchPromise = null;

export const useAuthStore = defineStore("auth", () => {
  // 尝试从 localStorage 恢复 token
  const token = ref(localStorage.getItem("access_token") || "");
  const user = ref(null);

  const setToken = (newToken) => {
    token.value = newToken;
    localStorage.setItem("access_token", newToken);
  };

  const clearAuth = () => {
    token.value = "";
    user.value = null;
    fetchPromise = null;
    localStorage.removeItem("access_token");
    // user.value = null
  };
  const fetchUserInfo = async () => {
    if (fetchPromise) {
      return fetchPromise;
    }
    try {
      // 时间戳破除缓存：在 URL 尾部加上 ?_t=${Date.now()}
      const url = `/api/auth/me?_t=${Date.now()}`;

      // 把请求过程挂载到锁变量上
      fetchPromise = axios.get(url);

      // 等待真实的请求结果
      const res = await fetchPromise;

      console.log("获取用户信息成功", res.data.data);
      user.value = res.data.data; // 把后端返回的用户对象存起来
    } catch (error) {
      console.error("获取用户信息失败，可能 Token 已过期", error);
    } finally {
      // 释放锁：无论请求成功还是报错，最后必须把锁解开，否则以后永远发不出新请求了
      fetchPromise = null;
    }
  };

  return { token, user, setToken, clearAuth, fetchUserInfo };
});
